import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const CredentialsListPageContext = React.createContext({});
export let CredentialsListPageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMCredentialsListPageGetContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  CredentialsListPageMachine = createMachine(_machineConfig, { services, actions });
  const [state, send] = useMachine(CredentialsListPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    CredentialsListPageMachine,
    CredentialsListPageState: state,
    CredentialsListPageSend: send,
  };
};
